import { Fragment } from 'react'

import { useScreen } from '../../../hooks'

import * as styles from './WidgetListPipeline.module.css'

function WidgetListPipeline({
  activeWidget,
  activeWidgetMobileContent,
  children,
  className = styles.WidgetListPipeline,
  items,
  renderItem,
  ...restProps
}) {
  const { isMobileScreenSize } = useScreen()

  return (
    <div className={className}>
      {items?.map((item, index) => {
        const isActive = item.name === activeWidget

        return (
          <Fragment key={item.name}>
            {renderItem({
              ...restProps,
              ...item,
              activeWidget,
              index,
              itemsLength: items.length,
            })}

            {isActive && isMobileScreenSize ? activeWidgetMobileContent : null}
          </Fragment>
        )
      })}
      {children}
    </div>
  )
}

export default WidgetListPipeline
